import { fmt, intl, customizedFmt } from 'components/IntlWrapper/IntlWrapper';
import ReviewStars from 'storeDesignBuilder/components/editor/form/components/layout/Sections/components/CustomerReviewsSection/components/ReviewItem/ReviewStars/ReviewStars';
import { LOCALE } from './intl-wrapper';

import { ReactComponent as VisaIcon } from 'assets/bosta-icons/visa-icon.svg';
import { ReactComponent as MasterCardIcon } from 'assets/bosta-icons/mastercard-icon.svg';
import { ReactComponent as MaestroIcon } from 'assets/bosta-icons/maestro-icon.svg';
import AmericanExpressIcon from 'assets/bosta-icons/americanexpress-image.png';
import ApplePayIcon from 'assets/bosta-icons/apple-pay-image.png';
import MadaIcon from 'assets/bosta-icons/mada-image.png';
import BasicThemeImg from 'assets/bosta-images/basic-theme.png';
import ProThemeImg from 'assets/bosta-images/pro-theme.png';
import ClassicThemeImg from 'assets/bosta-images/classic-theme.png';

export const SLLR_PAY_METHODS = {
  mastercard: {
    name: fmt({
      id: 'products.sllr_store.sllr_pay.saudi_services.master_card'
    }),
    logo: <MasterCardIcon />
  },
  visa: {
    name: fmt({
      id: 'products.sllr_store.sllr_pay.saudi_services.visa'
    }),
    logo: <VisaIcon />
  },
  mada: {
    name: fmt({
      id: 'products.sllr_store.sllr_pay.saudi_services.mada_card'
    }),
    logo: <img src={MadaIcon} alt="" />
  },
  maestro: {
    name: fmt({
      id: 'products.sllr_store.sllr_pay.saudi_services.maestro'
    }),
    logo: <MaestroIcon />
  },
  americanexpress: {
    name: fmt({
      id: 'products.sllr_store.sllr_pay.saudi_services.american_express'
    }),
    logo: <img src={AmericanExpressIcon} alt="" />
  },
  applepay: {
    name: fmt({
      id: 'products.sllr_store.sllr_pay.saudi_services.apple_pay'
    }),
    logo: <img src={ApplePayIcon} alt="" />
  }
};

export const RETURN_POLICY_TEMPLATES = {
  TEMP_ONE:
    intl.locale === LOCALE.EN
      ? '<p class="ql-align-right ql-direction-rtl"><strong>ما هي المدة التي يحتاجها العميل لإرجاع السلعة في حالة السماح بالإرجاع؟</strong></p><ul><li class="ql-align-right ql-direction-rtl"><span style="color: rgb(136, 136, 136);">اكتب اجابتك هنا.*</span></li></ul><p class="ql-align-right ql-direction-rtl"><br></p><p class="ql-align-right ql-direction-rtl"><strong>في أي حالة يمكن إرجاع العناصر؟</strong></p><ul><li class="ql-align-right ql-direction-rtl"><span style="color: rgb(136, 136, 136);">اكتب اجابتك هنا.*</span></li></ul><p class="ql-align-right ql-direction-rtl"><br></p><p class="ql-align-right ql-direction-rtl"><strong>كيف سأسترد أموالي؟</strong></p><ul><li class="ql-align-right ql-direction-rtl"><span style="color: rgb(136, 136, 136);">اكتب اجابتك هنا.*</span></li></ul><p class="ql-align-right ql-direction-rtl"><br></p><p class="ql-align-right ql-direction-rtl"><strong>هل المرتجعات مجانية أم سيتم تطبيق رسوم؟ وإذا لم يكن الأمر كذلك ، فكم هي رسوم الإرجاع؟</strong></p><ul><li class="ql-align-right ql-direction-rtl"><span style="color: rgb(136, 136, 136);">اكتب اجابتك هنا.*</span></li></ul><p class="ql-align-right ql-direction-rtl"><br></p><p class="ql-align-right ql-direction-rtl"><strong>كيف يعمل الاستبدال؟</strong></p><ul><li class="ql-align-right ql-direction-rtl"><span style="color: rgb(136, 136, 136);">اكتب اجابتك هنا.*</span></li></ul><p class="ql-align-right ql-direction-rtl"><br></p><p class="ql-align-right ql-direction-rtl"><strong>المنتجات الغير قابله للارجاع؟</strong></p><ul><li class="ql-align-right ql-direction-rtl"><span style="color: rgb(136, 136, 136);">اكتب اجابتك هنا.*</span></li></ul><p class="ql-align-right ql-direction-rtl"><br></p><p class="ql-align-right ql-direction-rtl"><strong>كيف يتم إرجاع عنصر؟</strong></p><ul><li class="ql-align-right ql-direction-rtl"><span style="color: rgb(136, 136, 136);">اكتب اجابتك هنا.*</span></li></ul><p><br></p><p><strong>How long does customer have to return an item if returns allowed?</strong></p><ul><li><em style="color: rgb(136, 136, 136);">Write your answer here.*</em></li></ul><p><br></p><p><strong>In what condition can items be returned?</strong></p><ul><li><em style="color: rgb(136, 136, 136);">Write your answer here.*</em></li></ul><p><br></p><p><strong>How will i be refunded, Cash? or back to the same payment method?</strong></p><ul><li><em style="color: rgb(136, 136, 136);">Write your answer here.*</em></li></ul><p><br></p><p><strong>Is returns free or fees will be applied? and if not how much is the return fees?</strong></p><ul><li><em style="color: rgb(136, 136, 136);">Write your answer here.*</em></li></ul><p><br></p><p><strong>How does Exchange works?</strong></p><ul><li><em style="color: rgb(136, 136, 136);">Write your answer here.*</em></li></ul><p><br></p><p><strong>Who will pay for shipping?</strong></p><ul><li><em style="color: rgb(136, 136, 136);">Write your answer here.*</em></li></ul><p><br></p><p><strong>How to return an item?</strong></p><ul><li><em style="color: rgb(136, 136, 136);">Write your answer here.*</em></li></ul>'
      : '<p><strong>ما هي المدة التي يحتاجها العميل لإرجاع السلعة في حالة السماح بالإرجاع؟</strong></p><ul><li><span style="color: rgb(136, 136, 136);">اكتب اجابتك هنا.*</span></li></ul><p><br></p><p><strong>في أي حالة يمكن إرجاع العناصر؟</strong></p><ul><li><span style="color: rgb(136, 136, 136);">اكتب اجابتك هنا.*</span></li></ul><p><br></p><p><strong>كيف سأسترد أموالي؟</strong></p><ul><li><span style="color: rgb(136, 136, 136);">اكتب اجابتك هنا.*</span></li></ul><p><br></p><p><strong>هل المرتجعات مجانية أم سيتم تطبيق رسوم؟ وإذا لم يكن الأمر كذلك ، فكم هي رسوم الإرجاع؟</strong></p><ul><li><span style="color: rgb(136, 136, 136);">اكتب اجابتك هنا.*</span></li></ul><p><br></p><p><strong>كيف يعمل الاستبدال؟</strong></p><ul><li><span style="color: rgb(136, 136, 136);">اكتب اجابتك هنا.*</span></li></ul><p><br></p><p><strong>المنتجات الغير قابله للارجاع؟</strong></p><ul><li><span style="color: rgb(136, 136, 136);">اكتب اجابتك هنا.*</span></li></ul><p><br></p><p><strong>كيف يتم إرجاع عنصر؟</strong></p><ul><li><span style="color: rgb(136, 136, 136);">اكتب اجابتك هنا.*</span></li></ul><p class="ql-align-right ql-direction-rtl"><br></p><p class="ql-align-right ql-direction-rtl"><strong>How long does customer have to return an item if returns allowed?</strong></p><ul><li class="ql-align-right ql-direction-rtl"><em style="color: rgb(136, 136, 136);">Write your answer here.*</em></li></ul><p class="ql-align-right ql-direction-rtl"><br></p><p class="ql-align-right ql-direction-rtl"><strong>In what condition can items be returned?</strong></p><ul><li class="ql-align-right ql-direction-rtl"><em style="color: rgb(136, 136, 136);">Write your answer here.*</em></li></ul><p class="ql-align-right ql-direction-rtl"><br></p><p class="ql-align-right ql-direction-rtl"><strong>How will i be refunded, Cash? or back to the same payment method?</strong></p><ul><li class="ql-align-right ql-direction-rtl"><em style="color: rgb(136, 136, 136);">Write your answer here.*</em></li></ul><p class="ql-align-right ql-direction-rtl"><br></p><p class="ql-align-right ql-direction-rtl"><strong>Is returns free or fees will be applied? and if not how much is the return fees?</strong></p><ul><li class="ql-align-right ql-direction-rtl"><em style="color: rgb(136, 136, 136);">Write your answer here.*</em></li></ul><p class="ql-align-right ql-direction-rtl"><br></p><p class="ql-align-right ql-direction-rtl"><strong>How does Exchange works?</strong></p><ul><li class="ql-align-right ql-direction-rtl"><em style="color: rgb(136, 136, 136);">Write your answer here.*</em></li></ul><p class="ql-align-right ql-direction-rtl"><br></p><p class="ql-align-right ql-direction-rtl"><strong>Who will pay for shipping?</strong></p><ul><li class="ql-align-right ql-direction-rtl"><em style="color: rgb(136, 136, 136);">Write your answer here.*</em></li></ul><p class="ql-align-right ql-direction-rtl"><br></p><p class="ql-align-right ql-direction-rtl"><strong>How to return an item?</strong></p><ul><li class="ql-align-right ql-direction-rtl"><em style="color: rgb(136, 136, 136);">Write your answer here.*</em></li></ul>',
  TEMP_TWO:
    intl.locale === LOCALE.EN
      ? '<p class="ql-direction-rtl ql-align-right">يمكن إرجاع المنتجات في غضون 30 يومًا من استلام الشحنة في معظم الحالات. يمكن إرجاع المنتجات التي تم تلقيها تالفة أو معيبة أو مستخدمة أو ينقصها أجزاء أو لا تتطابق مع المنتج الموصوف، في غضون 30 يومًا من استلام الشحنة. إلا أنه توجد سياسات أو متطلبات مختلفة لبعض المنتجات.</p><p class="ql-direction-rtl ql-align-right"><br></p><p class="ql-direction-rtl ql-align-right"><strong>لن تتم معالجة طلبات الإرجاع إلا في الحالات التالية:</strong></p><ul><li class="ql-direction-rtl ql-align-right">المنتج غير تالف.</li><li class="ql-direction-rtl ql-align-right">لا يختلف المنتج عما تم شحنه إليك.</li><li class="ql-direction-rtl ql-align-right">يتم إرجاع المنتج بنفس الحالة التي كان عليها عند استلامه (مع صندوق أو تغليف العلامة التجارية/ الشركة المصنعة الأصلي، وإذا كان ذلك ممكنًا، أي دليل مستخدم وبطاقة الضمان وجميع الملحقات).</li></ul><p><br></p><p>Items can be returned within 30 days of receipt of shipment in most cases. Items that were received damaged, defective, used, missing parts, or not as described could be returned within 30 days of receipt of shipment. Some products have different policies.</p><p><br></p><p><strong>Returns will be processed only if:</strong></p><ul><li>The product is not damaged.</li><li>The product is not different from what was shipped to you.</li><li>The product is returned in the same condition as when it was received (with the original brand /manufacturer box or packaging and, if applicable, any user manual, warranty card, and all accessories).</li></ul>'
      : '<p>يمكن إرجاع المنتجات في غضون 30 يومًا من استلام الشحنة في معظم الحالات. يمكن إرجاع المنتجات التي تم تلقيها تالفة أو معيبة أو مستخدمة أو ينقصها أجزاء أو لا تتطابق مع المنتج الموصوف، في غضون 30 يومًا من استلام الشحنة. إلا أنه توجد سياسات أو متطلبات مختلفة لبعض المنتجات.</p><p><br></p><p><strong>لن تتم معالجة طلبات الإرجاع إلا في الحالات التالية:</strong></p><ul><li>المنتج غير تالف.</li><li>لا يختلف المنتج عما تم شحنه إليك.</li><li>يتم إرجاع المنتج بنفس الحالة التي كان عليها عند استلامه (مع صندوق أو تغليف العلامة التجارية/ الشركة المصنعة الأصلي، وإذا كان ذلك ممكنًا، أي دليل مستخدم وبطاقة الضمان وجميع الملحقات).</li></ul><p class="ql-direction-rtl ql-align-right"><br></p><p class="ql-direction-rtl ql-align-right">Items can be returned within 30 days of receipt of shipment in most cases. Items that were received damaged, defective, used, missing parts, or not as described could be returned within 30 days of receipt of shipment. Some products have different policies.</p><p class="ql-direction-rtl ql-align-right"><br></p><p class="ql-direction-rtl ql-align-right"><strong>Returns will be processed only if:</strong></p><ul><li class="ql-direction-rtl ql-align-right">The product is not damaged.</li><li class="ql-direction-rtl ql-align-right">The product is not different from what was shipped to you.</li><li class="ql-direction-rtl ql-align-right">The product is returned in the same condition as when it was received (with the original brand /manufacturer box or packaging and, if applicable, any user manual, warranty card, and all accessories).</li></ul>'
};

export const STORE_PAGE_PATH = '/sllr/store';

export const POLICIES_INITIAL_SETTINGS = {
  returnPolicy: {
    allowReturn: true,
    returnConfig: {
      returnFees: 0,
      returnRange: 30,
      creationLang: intl.locale,
      returnRules: ''
    }
  }
};

export const REJECTED_LINK_CODES = {
  DUPLICATE: 13000,
  INVALID: 13003
};

export const SLLR_KEY = 'sllr';

export const TABLE_PAGE_SIZE_OPTIONS = [50, 100, 200];

export const DOMAIN_PLACEHOLDER = 'yourdomain.com';

export const REGEX_TLD = /\.[a-zA-Z]{2,}$/;

export const REGEX_HAS_SPECIAL_CHAR_EXCEPT_DOT_AND_HYPHEN = /[^a-zA-Z0-9.é-]/;

export const CUSTOM_DOMAINS_STATUSES = {
  PENDING: 'pending',
  CONNECTED: 'connected'
};

export const GODADDY_URL = 'GoDaddy.com';

export const INVALID_DOMAIN_CODES = {
  NOT_OWNED: 16003,
  ALREADY_CONNECTED: 16005
};

export const DNS_CONNECTION_ERROR = 16003;

export const CONNECTION_GUIDE_URLS = {
  EN: 'https://sllr.freshdesk.com/en/support/solutions/articles/36000456089-custom-domain-faqs',
  AR: 'https://sllr.freshdesk.com/ar/support/solutions/articles/36000456089-custom-domain-faqs'
};

export const MOYASAR_STATUS = {
  SEMI_ACTIVE: 'semi_active',
  ACTIVE: 'active',
  REJECTED: 'rejected',
  REVIEW_FAILED: 'review_failed',
  HOLD: 'hold',
  UN_HOLD: 'un_hold',
  DISABLED: 'disabled'
};

export const MOYASAR_REJECTED_STATUS = [
  MOYASAR_STATUS.REJECTED,
  MOYASAR_STATUS.HOLD
];

export const MOYASAR_NOT_ACTIVATED_STATUS = [
  MOYASAR_STATUS.SEMI_ACTIVE,
  MOYASAR_STATUS.REVIEW_FAILED,
  ...MOYASAR_REJECTED_STATUS
];

export const SLLR_SUPPORT_CLEANDAR_URL =
  'https://calendar.google.com/calendar/u/0/selfsched?sstoken=UU1DcTEyeGtVVUktfGRlZmF1bHR8YzE5NWQ3OGU2YjhhYjYzMTY4NTUwOTBhY2E0Mzk1N2M';

export const THEMES = [
  {
    title: fmt({ id: 'store_design.basic_theme.title' }),
    // subtitle: fmt({ id: 'store_design.basic_theme.subtitle' }),
    // bestFor: fmt({ id: 'store_design.basic_theme.for' }),
    isNew: false,
    image: BasicThemeImg,
    themeId: 'basic'
  },
  {
    title: fmt({ id: 'store_design.pro_theme.title' }),
    // subtitle: fmt({ id: 'store_design.pro_theme.subtitle' }),
    // bestFor: fmt({ id: 'store_design.pro_theme.for' }),
    isNew: true,
    image: ProThemeImg,
    themeId: 'proTheme1'
  },
  {
    title: fmt({ id: 'store_design.classic.title' }),
    // subtitle: fmt({ id: 'store_design.classic.subtitle' }),
    // bestFor: fmt({ id: 'store_design.classic.for' }),
    isNew: true,
    image: ClassicThemeImg,
    themeId: 'classic'
  }
];

export const EDITOR_HOMEPAGE_THEMES = ['proTheme1', 'classic'];

export const PANEL_KEYS = {
  DESIGN: 'design-style',
  HOMEPAGE: 'home-page'
};

export const STORE_EDITOR_PANELS = {
  basic: PANEL_KEYS.DESIGN,
  proTheme1: PANEL_KEYS.HOMEPAGE,
  classic: PANEL_KEYS.HOMEPAGE
};

export const HEADER_LAYOUT_TYPES = {
  MENU_AND_CENTERED_LOGO: 'MENU_AND_CENTERED_LOGO',
  MENU_AND_SIDE_LOGO: 'MENU_AND_SIDE_LOGO',
  CENTERED_LINKS_AND_CENTERED_LOGO: 'CENTERED_LINKS_AND_CENTERED_LOGO',
  SIDE_LINKS_AND_SIDE_LOGO: 'SIDE_LINKS_AND_SIDE_LOGO'
};

export const FOOTER_LAYOUT_TYPES = {
  PLAIN: 'PLAIN',
  STORE_NAME: 'STORE_NAME',
  STORE_NAME_DESCRIPTION: 'STORE_NAME_DESCRIPTION',
  STORE_NAME_DESCRIPTION_LINKS: 'STORE_NAME_DESCRIPTION_LINKS'
};

export const BANNER_LAYOUT_TYPES = {
  DEFAULT: 'default-banner-layout',
  IMAGE_SPLIT: 'image-split-default-banner-layout',
  IMAGE_HEADER: 'image-header-default-banner-layout'
};

export const STORE_EDITOR_MODES = {
  HEADER: 'header',
  FOOTER: 'footer',
  MAIN: 'main',
  BANNER: 'banner',
  PRODUCTS: 'products',
  CATEGORIES: 'categories',
  CUSTOMER_REVIEWS: 'customerReviews',
  BENEFITS: 'benefits'
};

export const ITEM_SIZES = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
  AUTO: 'auto'
};

export const BANNER_ALIGNMENT = {
  LEFT: 'left',
  CENTER: 'center',
  RIGHT: 'right'
};

export const COLOR_SCHEMES = [
  {
    value: 'LIGHT',
    label: fmt({ id: 'store_design.store_editor.homepage.header.light' }),
    colorClass: 'light'
  },
  {
    value: 'DARK',
    label: fmt({ id: 'store_design.store_editor.homepage.header.dark' }),
    colorClass: 'dark'
  },
  {
    value: 'SHADED',
    label: fmt({ id: 'store_design.store_editor.homepage.footer.shaded' }),
    colorClass: 'shaded'
  }
];

export const BASIC_THEME = 'basic';

export const BANNER_HEIGHT = 'bannerHeight';

export const CUSTOMER_REVIEWS_MAX_STARS_RATE = 5;

export const CUSTOMER_REVIEWS_INITIAL_VALUES = {
  type: 'customerReviews',
  name: 'customerReviews',
  title: fmt({
    id: 'store_design.reviews_section.title_for_store'
  }),
  titleAr: customizedFmt(LOCALE.AR)({
    id: 'store_design.reviews_section.title_for_store'
  }),
  customerReviews: [
    {
      image:
        'https://storage.googleapis.com/bosta-files/sllr_store_images/review-customer-placeholder.png',
      auther: fmt({
        id: 'store_design.reviews_section.initial_reviews.review_1.auther'
      }),
      autherAr: customizedFmt(LOCALE.AR)({
        id: 'store_design.reviews_section.initial_reviews.review_1.auther'
      }),
      description: fmt({
        id: 'store_design.reviews_section.initial_reviews.review_1.description'
      }),
      descriptionAr: customizedFmt(LOCALE.AR)({
        id: 'store_design.reviews_section.initial_reviews.review_1.description'
      }),
      rating: CUSTOMER_REVIEWS_MAX_STARS_RATE
    },
    {
      image:
        'https://storage.googleapis.com/bosta-files/sllr_store_images/review-customer-placeholder.png',
      auther: fmt({
        id: 'store_design.reviews_section.initial_reviews.review_2.auther'
      }),
      autherAr: customizedFmt(LOCALE.AR)({
        id: 'store_design.reviews_section.initial_reviews.review_2.auther'
      }),
      description: fmt({
        id: 'store_design.reviews_section.initial_reviews.review_2.description'
      }),
      descriptionAr: customizedFmt(LOCALE.AR)({
        id: 'store_design.reviews_section.initial_reviews.review_2.description'
      }),
      rating: CUSTOMER_REVIEWS_MAX_STARS_RATE
    },
    {
      image:
        'https://storage.googleapis.com/bosta-files/sllr_store_images/review-customer-placeholder.png',
      auther: fmt({
        id: 'store_design.reviews_section.initial_reviews.review_3.auther'
      }),
      autherAr: customizedFmt(LOCALE.AR)({
        id: 'store_design.reviews_section.initial_reviews.review_3.auther'
      }),
      description: fmt({
        id: 'store_design.reviews_section.initial_reviews.review_3.description'
      }),
      descriptionAr: customizedFmt(LOCALE.AR)({
        id: 'store_design.reviews_section.initial_reviews.review_3.description'
      }),
      rating: CUSTOMER_REVIEWS_MAX_STARS_RATE
    }
  ]
};

const HEADER_DEFAULT_LINKS = [
  {
    title: 'Home',
    titleAr: 'الرئيسية',
    value: '/home',
    isEditable: false
  },
  {
    title: 'Shop',
    titleAr: 'تسوق',
    value: '/shop',
    isEditable: false
  },
  {
    title: 'Sale',
    titleAr: 'تخفيضات',
    value: '/sale',
    canBeHidden: true,
    isHidden: false,
    isEditable: false
  }
];

const BANNER_DEFAULT_VALUES = [
  {
    title: 'Our New Collection is Here!',
    description:
      'Don’t miss out on our new collection. Shop our latest products and get the best offers.',
    cta: {
      label: 'Shop Now',
      link: '/shop'
    },
    overlay: 20
  }
];

export const DEFAULT_THEME_VALUES = (initialCategories) => {
  return {
    basic: {
      variables: {
        borderRadius: '8px',
        fontFamily: 'default',
        brandColor: '#000000ff'
      },
      storeStructure: {
        choosenThemeId: 'basic',
        createdAt: new Date().toISOString()
      }
    },
    proTheme1: {
      variables: {
        borderRadius: '8px',
        fontFamily: 'default',
        brandColor: '#000000ff',
        productImageLayout: 'square',
        productImageFit: 'fill'
      },
      storeStructure: {
        choosenThemeId: 'proTheme1',
        createdAt: new Date().toISOString(),
        proTheme1: {
          header: {
            colorScheme: 'LIGHT',
            layout: HEADER_LAYOUT_TYPES.CENTERED_LINKS_AND_CENTERED_LOGO,
            links: HEADER_DEFAULT_LINKS
          },
          footer: {
            colorScheme: 'LIGHT',
            layout: FOOTER_LAYOUT_TYPES.PLAIN
          },
          HomePageSections: [
            {
              type: 'banner',
              title: 'Banner',
              titleAr: 'Banner',
              name: 'banner',
              bannerHeight: 'large',
              bannerAlignment: 'center',
              layout: BANNER_LAYOUT_TYPES.DEFAULT,
              banners: BANNER_DEFAULT_VALUES
            },
            {
              type: 'products',
              title: 'Trending Products',
              titleAr: 'Trending Products',
              name: 'trendingProducts'
            },
            {
              type: 'categories',
              title: 'Featured Categories',
              titleAr: 'أقسام مميزة',
              name: 'featuredCategories',
              selectedCategories: initialCategories
            },
            CUSTOMER_REVIEWS_INITIAL_VALUES
          ]
        }
      }
    },
    classic: CLASSIC_THEME_VALUES(initialCategories)
  };
};

const CLASSIC_THEME_VALUES = (initialCategories) => ({
  variables: {
    borderRadius: '0px',
    fontFamily: 'default',
    brandColor: '#000000ff',
    productImageLayout: 'square',
    productImageFit: 'fill'
  },
  storeStructure: {
    choosenThemeId: 'classic',
    createdAt: new Date().toISOString(),
    classic: {
      header: {
        colorScheme: 'TRANSPARENT',
        layout: HEADER_LAYOUT_TYPES.SIDE_LINKS_AND_SIDE_LOGO,
        links: HEADER_DEFAULT_LINKS
      },
      footer: {
        colorScheme: 'LIGHT',
        layout: FOOTER_LAYOUT_TYPES.STORE_NAME_DESCRIPTION_LINKS
      },
      HomePageSections: [
        {
          type: 'banner',
          title: 'Banner',
          titleAr: 'Banner',
          name: 'banner',
          bannerAlignment: 'center',
          bannerHeight: 'large',
          buttonSize: 'small',
          colorScheme: 'DARK',
          layout: BANNER_LAYOUT_TYPES.IMAGE_HEADER,
          banners: BANNER_DEFAULT_VALUES
        },
        {
          type: 'categories',
          title: 'Featured Categories',
          titleAr: 'أقسام مميزة',
          name: 'featuredCategories',
          selectedCategories: initialCategories
        },
        CUSTOMER_REVIEWS_INITIAL_VALUES,
        {
          type: 'banner',
          title: 'Banner',
          titleAr: 'Banner',
          name: 'banner',
          bannerHeight: 'small',
          layout: BANNER_LAYOUT_TYPES.DEFAULT,
          banners: [
            {
              overlay: 20
            }
          ]
        },
        {
          type: 'products',
          title: 'Trending Products',
          titleAr: 'Trending Products',
          name: 'trendingProducts'
        }
      ]
    }
  }
});

export const GOTO_OPTIONS = [
  {
    label: fmt({ id: 'store_design.store_editor.homepage.sections.homepage' }),
    value: '/home'
  },
  {
    label: fmt({ id: 'store_design.store_editor.homepage.sections.shop_page' }),
    value: '/shop'
  },
  {
    label: fmt({
      id: 'store_design.store_editor.homepage.sections.specific_product'
    }),
    value: 'product'
  },
  {
    label: fmt({
      id: 'store_design.store_editor.homepage.sections.specific_category'
    }),
    value: 'category'
  },
  {
    label: fmt({
      id: 'store_design.store_editor.homepage.sections.store_info'
    }),
    value: 'storeInfo'
  },
  {
    label: fmt({
      id: 'store_design.store_editor.homepage.sections.return_policy'
    }),
    value: 'returnPolicy'
  },
  {
    label: fmt({
      id: 'store_design.store_editor.homepage.sections.contact_us'
    }),
    value: 'contact'
  }
];

export const PRODUCTS_SECTION = 'products';
export const TRENDING = 'trendingProducts';
export const SPECIFIC_CATEGORY = 'specificCategory';
export const SPECIFIC_PRODUCTS = 'specificProducts';

export const PRODUCTS_OPTIONS = [
  {
    label: fmt({ id: `store_design.products_section.trending` }),
    value: TRENDING
  },
  {
    label: fmt({ id: `store_design.products_section.specific_category` }),
    value: 'specificCategory'
  },
  {
    label: fmt({ id: `store_design.products_section.specific_product` }),
    value: 'specificProducts'
  }
];
export const CONNECTED_DOMAIN = 'DOMAIN_CONNECTED';

export const HELP_ARTICLES_URLS = {
  EN: 'https://sllr.freshdesk.com/en/support/solutions/articles/36000474380-sllr-facing-problems-connecting-your-domain-',
  AR: 'https://sllr.freshdesk.com/ar/support/solutions/articles/36000474380-%D8%B3%D9%84%D8%B1-%D9%87%D9%84-%D8%AA%D9%88%D8%A7%D8%AC%D9%87-%D9%85%D8%B4%D8%A7%D9%83%D9%84-%D9%81%D9%8A-%D8%AA%D9%88%D8%B5%D9%8A%D9%84-%D8%A7%D9%84%D8%AF%D9%88%D9%85%D9%8A%D9%86-%D8%A7%D9%84%D8%AE%D8%A7%D8%B5-%D8%A8%D9%83%D8%9F'
};

export const DOMAIN_VIEWED = 'isCustomDomainBannerViewed';

export const BANNER_IMAGE_PLACEHOLDER =
  'https://storage.googleapis.com/bosta-fe/Business-Dashboard/BannerPlaceholder.png';

export const REVIEW_STARTS_OPTIONS = [
  {
    label: <ReviewStars count={5} />,
    value: 5
  },
  {
    label: <ReviewStars count={4} />,
    value: 4
  },
  {
    label: <ReviewStars count={3} />,
    value: 3
  },
  {
    label: <ReviewStars count={2} />,
    value: 2
  },
  {
    label: <ReviewStars count={1} />,
    value: 1
  },
  {
    label: fmt({
      id: 'store_design.reviews_section.hide_stars'
    }),
    value: null
  }
];

export const ORDERS_PAYMENT_STATUS = {
  ONLINE: 'online',
  CASH: 'cash',
  COMBINED: 'combined'
};
